export default __webpack_public_path__ + "static/media/bg2m.47017fcf.png";